import classnames from 'classnames'
import Drift from 'components/Drift'
import useResolvePrivacyPolicy from 'hooks/useResolvePrivacyPolicy'
import useThemeColors from 'hooks/useThemeColors'
import { getEmbedConfiguration } from 'modules/embed/selectors'
import React from 'react'
import { useSelector } from 'react-redux'

import './style.css'

const Footer = () => {
  const { showBranding = false } = useSelector(getEmbedConfiguration)

  const { privacyPolicyLink, privacyPolicyLinkText, noPolicy } = useResolvePrivacyPolicy()
  const { footerTextColor } = useThemeColors()

  if (!showBranding && noPolicy) { return null }

  return (
    <div className={classnames("drift-widget-footer", {
      "drift-widget-footer--with-branding": showBranding
    })}>
      {showBranding && <Drift />}
      {showBranding && !noPolicy && (
        <span
          className="drift-widget-footer-privacy-spacer"
          aria-hidden="true"
          style={footerTextColor}
        >
          |
        </span>
      )}
      {!noPolicy && (
        <a
          href={privacyPolicyLink}
          rel="noopener noreferrer"
          target="_blank"
          title={privacyPolicyLinkText}
          className="drift-widget-footer-privacy-link"
          style={footerTextColor}
        >
          {privacyPolicyLinkText}
        </a>
      )}
    </div>
  )
}

export default Footer
